import api from "./Api";

class ServicosCnaeGruposService {
  GetServicosCnaeGrupos(payload) {
    return api.get("/v1/servicosCnaeGrupos/" + payload).then((response) => {
      return response.data;
    });
  }

  PostServicosCnaeGrupos(payload) {
    return api.post("/v1/servicosCnaeGrupos/", payload).then((response) => {
      return response.data;
    });
  }

  PutServicosCnaeGrupos(payload) {
    return api.put("/v1/servicosCnaeGrupos/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteServicosCnaeGrupos(payload) {
    return api.delete("/v1/servicosCnaeGrupos/" + payload).then((response) => {
      return response.data;
    });
  }

  GetServicosCnaeGruposOData(payload) {
    return api.get("/OData/ServicosCnaeGrupos" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new ServicosCnaeGruposService();
